import * as React from 'react';

function SvgCompressor(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.2 72" {...props}>
      <path
        className="compressor_svg__st0"
        d="M18.6 5.6c10.8-6.1 24.3-6.1 35.1 0S71.2 23.1 71.2 36c0 12.2-6.8 23.6-17.6 30.4-10.8 6.1-24.3 6.1-35.1 0S1 48.9 1 36 7.8 11.7 18.6 5.6zm-2.1 8.9C10.4 19.8 7.1 28 7.1 36s3.3 16.2 9.4 21.5l45.9-10.1c3.3-7.5 3.3-15.5 0-22.9l-45.9-10zm41.9 3.2C49.7 7 35.4 4.2 23.2 9.5l35.2 8.2zM23.2 62.5c12.2 6.1 26.9 2.8 35.1-8.2l-35.1 8.2z"
      />
      {props.style?.transform !== 'none' && (
        <animateTransform
          accumulate="none"
          additive="replace"
          attributeName="transform"
          begin="0s"
          calcMode="linear"
          dur="5s"
          fill="remove"
          from="0 0 0"
          repeatCount="indefinite"
          restart="always"
          to="360 0 0"
          type="rotate"
        />
      )}
    </svg>
  );
}

export default SvgCompressor;
